/* np-locator.js: behaviour for sections/new-locator.liquid ("Store Locator.dc.html").
   Town search and type filter over the server-rendered location cards; picking a
   card opens its tags and Directions and points the map at it. The map iframe is
   only loaded when the map column is actually shown (not on phones). */
(function () {
  "use strict";
  var root = document.querySelector("#np-root.nloc");
  if (!root) return;
  var cards = [].slice.call(root.querySelectorAll("[data-loc]"));
  var q = document.getElementById("nloc-q");
  var count = document.getElementById("nloc-count");
  var none = document.getElementById("nloc-none");
  var frame = document.getElementById("nloc-frame");
  var mapBox = document.getElementById("nloc-map");
  var label = document.getElementById("nloc-map-label");
  var typeBtns = [].slice.call(root.querySelectorAll("#nloc-types [data-type]"));
  var type = "all";

  function mapShown() { return mapBox && getComputedStyle(mapBox).display !== "none"; }
  function point(card) {
    if (!frame || !card) return;
    var src = "https://maps.google.com/maps?q=" + encodeURIComponent(card.getAttribute("data-map")) + "&z=14&output=embed";
    if (mapShown()) {
      if (frame.getAttribute("src") !== src) frame.setAttribute("src", src);
    } else {
      frame.setAttribute("data-src", src);
    }
    frame.title = "Map: " + card.querySelector(".nloc-name").textContent;
    if (label) label.textContent = card.querySelector(".nloc-name").textContent;
  }
  function select(card) {
    cards.forEach(function (c) {
      var on = c === card;
      c.classList.toggle("is-sel", on);
      c.setAttribute("aria-expanded", on ? "true" : "false");
    });
    point(card);
  }
  function apply() {
    var term = (q.value || "").trim().toLowerCase();
    var shown = cards.filter(function (c) {
      var okType = type === "all" || c.getAttribute("data-type") === type;
      var okText = !term || c.getAttribute("data-search").indexOf(term) > -1;
      c.hidden = !(okType && okText);
      return okType && okText;
    });
    count.textContent = "Showing " + shown.length + " location" + (shown.length === 1 ? "" : "s") + " across the UK";
    none.hidden = shown.length > 0;
    var sel = root.querySelector("[data-loc].is-sel");
    if (shown.length && (!sel || sel.hidden)) select(shown[0]);
  }

  cards.forEach(function (c) {
    c.addEventListener("click", function (e) {
      if (e.target.closest("a")) return;
      select(c);
    });
    c.addEventListener("keydown", function (e) {
      if ((e.key === "Enter" || e.key === " ") && e.target === c) { e.preventDefault(); select(c); }
    });
  });
  typeBtns.forEach(function (b) {
    b.addEventListener("click", function () {
      type = b.getAttribute("data-type");
      typeBtns.forEach(function (x) {
        var on = x === b;
        x.classList.toggle("is-on", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      apply();
    });
  });
  q.addEventListener("input", apply);

  /* load the map for the first location once the map column is visible */
  function loadMap() {
    if (!frame || !mapShown()) return;
    var s = frame.getAttribute("data-src");
    if (s && !frame.getAttribute("src")) frame.setAttribute("src", s);
  }
  loadMap();
  window.addEventListener("resize", loadMap);
  if (window.npSwipe) window.npSwipe();
})();
